import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-855515b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "initial-container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { className: "text-container" }
const _hoisted_4 = { className: "title" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "form-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filler" }, null, -1))

import Form from "@/components/layouts/Form.vue";
import GenericButton from "@/components/buttons/GenericButton.vue";
import ReportErrorIconButton from "@/components/buttons/ReportErrorIconButton/ReportErrorIconButton.vue";
import MobileNavigationBar from "@/components/layouts/MobileNavigationBar/MobileNavigationBar.vue";
import { ActionTypes, MutationTypes } from "@/store";
import { handleOnboardingRedirect } from "@/utils/settings";
import {
  getInitialFormData,
  getIsFormValid,
  loginFormFields,
} from "@/utils/form";
import {
  FormFieldDataObject,
  FormFieldNameEnum,
  FormFieldType,
  FormType,
  LoginFormDataObjectType,
} from "@/types/form";
import { reactive } from "vue";
import { useStore } from "vuex";
import { getRefreshTokenAsync } from "@/services/maitrejaApi/auth";
import { GenericButtonVariantEnum } from "@/types/button";
import { useI18n } from "vue-i18n";
import { MobileNavigationBarIconType } from "@/types/app";
import { handleMountErrorMessageSnackbar } from "@/utils/app";
import { loginEmailSnackbarErrorObject } from "@/utils/auth";
import Input from "../forms/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginEmail',
  setup(__props) {

const { commit, dispatch } = useStore();
const { t } = useI18n();

const data = reactive<FormFieldDataObject<LoginFormDataObjectType>>(
  getInitialFormData<LoginFormDataObjectType>(loginFormFields),
);

const handleSubmit = async () => {
  const isFormValid = getIsFormValid<LoginFormDataObjectType>(
    data,
    loginFormFields,
    FormType.Login,
  );
  if (!isFormValid) {
    return;
  }

  try {
    commit(MutationTypes.SET_IS_LOADING, true);
    await getRefreshTokenAsync(data.email, data.password);
    await dispatch(ActionTypes.LOGIN_AUTH);
    data.errors = {
      password: "",
      email: "",
    };
    handleOnboardingRedirect();
  } catch (error) {
    handleMountErrorMessageSnackbar(error, loginEmailSnackbarErrorObject);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReportErrorIconButton),
    _createVNode(MobileNavigationBar, {
      "icon-type": _unref(MobileNavigationBarIconType).Circle
    }, null, 8, ["icon-type"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)("auth.login")), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("welcome.loginWithCredentials")), 1)
      ]),
      _createVNode(Form, { onSubmitForm: handleSubmit }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Input, {
              modelValue: data.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.email) = $event)),
              name: _unref(FormFieldNameEnum).Email,
              placeholder: "auth.email",
              required: "",
              errors: data.errors
            }, null, 8, ["modelValue", "name", "errors"]),
            _createVNode(Input, {
              modelValue: data.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.password) = $event)),
              name: _unref(FormFieldNameEnum).Password,
              type: _unref(FormFieldType).Password,
              placeholder: "auth.password",
              required: "",
              errors: data.errors
            }, null, 8, ["modelValue", "name", "type", "errors"]),
            _createVNode(GenericButton, {
              variant: _unref(GenericButtonVariantEnum).Primary,
              text: "auth.buttons.login"
            }, null, 8, ["variant"])
          ])
        ]),
        _: 1
      })
    ]),
    _hoisted_7
  ]))
}
}

})